import { createAction as makeActionCreator } from 'redux-actions';

import api from '../api/';
import { handleError } from './errors';

export const organizationReceived = makeActionCreator('ORGANIZATION_RECEIVED');

export const fetchOrganization = dispatch => () => {
  console.log('Fetching organization');
  api.requestOrganization()
  .then((organizationData) => {
    dispatch(organizationReceived(organizationData));
  })
  .catch(dispatch(handleError));
};



// WEBPACK FOOTER //
// ./src/actions/organization.js